export default "__VITE_ASSET__D$F8bozE__"